module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "kb-fab",
    style: (_vm.fabStyle),
    on: {
      "mousedown": _vm.onFabDown,
      "click": _vm.onFabClick
    }
  }, [_vm._v("知识")]), _vm._v(" "), (_vm.open && _vm.maximized) ? _c('div', {
    staticClass: "kb-mask",
    on: {
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onMaskDown.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "kb-panel",
    style: (_vm.panelStyle),
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kb-head",
    on: {
      "mousedown": _vm.onWinDragDown
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "kb-actions",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearChat.apply(null, arguments)
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleMaximize.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.maximized ? '缩小' : '放大'))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePanel.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('div', {
    ref: "msgs",
    staticClass: "kb-msgs"
  }, [(!_vm.messages.length) ? _c('div', {
    staticClass: "kb-empty"
  }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(m, idx) {
    return _c('div', {
      key: idx,
      staticClass: "kb-bubble",
      class: m.role
    }, [_c('div', [_vm._v(_vm._s(m.text))]), _vm._v(" "), (m.sources && m.sources.length) ? _c('div', {
      staticClass: "kb-sources"
    }, [_vm._v("\n          来源：\n          "), _vm._l((m.sources), function(s, i) {
      return _c('span', {
        key: i
      }, [_vm._v(_vm._s(s.kbName || s.title) + _vm._s(i < m.sources.length - 1 ? '、' : ''))])
    })], 2) : _vm._e()])
  }), _vm._v(" "), (_vm.sending) ? _c('div', {
    staticClass: "kb-empty"
  }, [_vm._v(_vm._s(_vm.hasBind ? '正在检索知识库…' : '思考中…'))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "kb-foot"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft),
      expression: "draft"
    }],
    attrs: {
      "maxlength": "1000",
      "placeholder": "输入问题，Enter 发送（Shift+Enter 换行）"
    },
    domProps: {
      "value": (_vm.draft)
    },
    on: {
      "keydown": _vm.onKey,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.draft = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#64748b"
    }
  }, [_vm._v(_vm._s(_vm.providerHint))]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.sending
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发送")])], 1)]), _vm._v(" "), _vm._l((_vm.resizeDirs), function(dir) {
    return _c('div', {
      key: dir,
      staticClass: "kb-resize",
      class: dir,
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onResizeDown(dir, $event)
        }
      }
    })
  })], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("知识助手")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3e402dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kb/KbAssistant.vue
// module id = 1922
// module chunks = 8